import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPharmacyInfo } from "../common/getPharmacyInfo";
import { getCurrentUserDetails } from "../../../redux/modules/user/actions";
import { H1 } from "./common-components";
import headingImageBlue from "../images/heading-image-blue.png";
import headingImageGreen from "../images/heading-image-green.png";
import headingImageSilver from "../images/heading-image-silver.png";
import { AllergicRhinitisDocTypes, MedicationReviewDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";
import { InterventionFormTypes } from "../../patient/Patient-Menu/Interventions/data";

export const FormHeader = ({
  cover = false,
  formType,
  section = null,
  alertData = null,
  pharmacyLocation = null,
  pharmacyName: pharmacyNameProp,
  pharmacyStoreNumber: pharmacyStoreNumberProp,
  pharmacyPhone: pharmacyPhoneProp,
  pharmacyFax: pharmacyFaxProp,
  pharmacyEmail: pharmacyEmailProp,
}) => {
  const { currentLoggedInUserDetail: userFromCurrentState } = useSelector((state) => state.currentLoggedInUserDetail ?? {});
  const usersState = useSelector((state) => state.users);
  const { currentLoggedInUserDetail: userFromUsers, pharmacyStores } = usersState ?? {};
  const dispatch = useDispatch();

  const currentLoggedInUserDetail = userFromCurrentState ?? userFromUsers;

  useEffect(() => {
    if (!currentLoggedInUserDetail) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
      const userId = userInfo.userId;
      if (userId) {
        dispatch(getCurrentUserDetails(userId, false));
      }
    }
  }, [currentLoggedInUserDetail, dispatch]);

  const rx = getPharmacyInfo(currentLoggedInUserDetail, pharmacyStores) ?? {};

  const pharmacyName = pharmacyNameProp ?? rx.pharmacyName ?? "";
  const pharmacyStoreNumber = pharmacyStoreNumberProp ?? rx.pharmacyStoreNumber ?? "";
  const pharmacyPhone = pharmacyPhoneProp ?? rx.pharmacyPhone ?? "";
  const pharmacyFax = pharmacyFaxProp ?? rx.pharmacyFax ?? "";
  const pharmacyEmail = pharmacyEmailProp ?? rx.pharmacyEmail ?? "";
  const normalizedPharmacyLocation =
    typeof pharmacyLocation === "string"
      ? pharmacyLocation.trim().toLowerCase()
      : "";

  let title = "Form Title";
  let subTitle = null;
  let headingImage = headingImageBlue;

  switch (formType) {
    case AllergicRhinitisDocTypes.InitialAssessment:
      title = "Pharmacist Initial Assessment Form";
      headingImage = headingImageBlue;
      break;
    case AllergicRhinitisDocTypes.PhysicianReferralForm:
      title = "Primary Provider Referral Form";
      headingImage = headingImageBlue;
      break;
    case AllergicRhinitisDocTypes.PatientReferral:
      title = "Patient Referral Form";
      headingImage = headingImageBlue;
      break;
    case AllergicRhinitisDocTypes.PrescribingRecord:
      title = "Pharmacist Prescribing Record";
      headingImage = headingImageBlue;
      break;
    case AllergicRhinitisDocTypes.PrescribingRecordWithReferral:
      title = "Pharmacist Prescribing Record with Referral";
      headingImage = headingImageBlue;
      break;
    case AllergicRhinitisDocTypes.Prescription:
      title = alertData?.EndServiceAndRefer
        ? "Minor Ailment Rx - Bill for Service Only\n(End Service & Refer)"
        : (normalizedPharmacyLocation || "current") === "current"
          ? "Minor Ailment - Rx"
          : normalizedPharmacyLocation === "alternate"
          ? "Minor Ailment Rx - Alternate Pharmacy"
          : "Minor Ailment Rx - Bill for Service Only\n(End Service & Refer)";
      headingImage = headingImageBlue;
      break;
    case AllergicRhinitisDocTypes.CommunicationForBilling:
      title = alertData?.EndServiceAndRefer
        ? "Minor Ailment Referral - Bill for Service Only"
        : "Minor Ailment Rx - Bill for Service Only\n(End Service & Refer)";
      subTitle = alertData?.EndServiceAndRefer
        ? "End Service & Refer"
        : normalizedPharmacyLocation === "alternate"
        ? "Filling Rx at alternate pharmacy"
        : null;
      headingImage = headingImageBlue;
      break;
    case MedicationReviewDocTypes.PharmacistWorksheet:
      title = "Pharmacists Worksheet - Annual Medication Review";
      break;
    case MedicationReviewDocTypes.StoryBoard:
      title = "Take Home Summary";
      break;
    case InterventionFormTypes.InterventionDocumentation:
      title = "Intervention Communication Form";
      subTitle = "Please complete and return the form to the pharmacy.";
      headingImage = headingImageBlue;
      break;
    case AllergicRhinitisDocTypes.Notepad:
      title = "Minor Ailment Prescribing Service - Notepad";
      headingImage = headingImageBlue;
      break;
    case AllergicRhinitisDocTypes.NotepadPharmacist:
      title = "Notepad - Pharmacist Comments";
      headingImage = headingImageBlue;
      break;
    case AllergicRhinitisDocTypes.NotepadPatient:
      title = "Notepad - Patient Comments";
      headingImage = headingImageBlue;
      break;
    case MedicationReviewDocTypes.Notepad:
      title = "Notepad";
      headingImage = headingImageBlue;
      break;
    case MedicationReviewDocTypes.NotepadPharmacist:
      title = "Notepad - Pharmacist Comments";
      headingImage = headingImageBlue;
      break;
    case MedicationReviewDocTypes.NotepadPatient:
      title = "Notepad - Patient Comments";
      headingImage = headingImageBlue;
      break;
    case "patientChart":
      title = "Patient Chart";
      headingImage = headingImageBlue;
      break;
    default:
      break;
  }

  if (formType === "patientChart" && section) {
    const map = {
      pharmacist: "Pharmacist Comments",
      patient: "Patient Comments",
    };
    const suffix = map[section] || section;
    title = `${title} - ${suffix}`;
  }

  return (
    <div className="relative">
      <img
        src={headingImage}
        className="absolute object-cover object-center w-full h-full"
      />
      {/* {[
        AllergicRhinitisDocTypes.InitialAssessment,
        AllergicRhinitisDocTypes.PhysicianReferralForm,
        AllergicRhinitisDocTypes.PrescribingRecord,
        AllergicRhinitisDocTypes.PrescribingRecordWithReferral,
        AllergicRhinitisDocTypes.PatientReferral,
      ].includes(formType) && ( */}
      <div className="relative px-9">
        <div
          className={`w-full mx-auto space-y-[-30px] pt-5 ${
            subTitle ? "pb-0" : "pb-4"
          }`}
        >
          <div className="flex flex-row items-center justify-between w-full flex-nowrap ">
            <img 
              // src={healthCompassLogo} 
              src="/icons/logos/health-compass.svg"
              className="h-[51px] min-w-[280px] self-start ml-[-20px]" 
            />
            <div className="w-auto px-6">
              <p className="min-w-[200px] text-[12px] font-semibold text-gray-700 text-center bg-white border border-gray-700 rounded-[10px] py-2">{pharmacyName || "Pharmacy Name/Logo"}</p>
              <div className="mt-[10px] flex flex-col gap-y-[4px] text-[12px] text-gray-700">
                <p><span className="font-medium">Store #</span> {pharmacyStoreNumber || "—"}</p>
                <p><span className="font-medium">Phone Number</span> {pharmacyPhone || "—"}</p>
                <p><span className="font-medium">Fax</span> {pharmacyFax || "—"}</p>
                <p><span className="font-medium">Email</span> {pharmacyEmail || "—"}</p>
              </div>
            </div>
          </div>
          <div className="max-w-[calc(100%-250px)]">
            <H1
              className={`text-teal-300 ${cover ? "whitespace-nowrap" : "whitespace-pre-line"}`}
            >{`${title} ${cover ? "Cover Letter" : ""}`}</H1>
            {subTitle &&
              (formType === InterventionFormTypes.InterventionDocumentation ? (
                <p className="text-teal-300 text-[14px] leading-[28px] font-normal whitespace-nowrap">{`${subTitle}`}</p>
              ) : (
                <H1 className="text-teal-300 whitespace-nowrap">{`${subTitle}`}</H1>
              ))}
          </div>
        </div>
      </div>
      {/* )}
      {[
        AllergicRhinitisDocTypes.Prescription,
        AllergicRhinitisDocTypes.CommunicationForBilling,
      ].includes(formType) && (
        <div className="relative p-9 flex flex-col gap-[0.114167in] items-center">
          <p className="text-[0.199792in] font-semibold text-gray-700 bg-white px-[0.228333in] py-[0.085625xin] border border-gray-700 w-fit">
            {pharmacyName}
          </p>
          {formType === AllergicRhinitisDocTypes.Prescription && (
            <div className="flex flex-col items-center gap-[0.000000in] font-medium text-[0.156979in]">
              <p>Store #</p>
              <p>Address</p>
              <p>Phone</p>
              <p>Email Address</p>
            </div>
          )}
          {formType === AllergicRhinitisDocTypes.CommunicationForBilling && (
            <H1 className="pt-4">{title}</H1>
          )}
        </div>
      )} */}
    </div>
  );
};
